import { jsxs as l, Fragment as f, jsx as t } from "@emotion/react/jsx-runtime";
import { useRef as N, useState as M, useId as P, useEffect as G, useCallback as $ } from "react";
import { useTheme as _ } from "@emotion/react";
import { CheckboxContainer as j, StyledActivityContainer as F, CheckboxInput as S, StyledIcon as W, sizes as u, PaddedText as J, InnerCheckbox as Q } from "./Checkbox.styled.js";
import { CHECKBOX_BACKGROUND_BORDER_RADIUS_SMALL as V, CHECKBOX_BACKGROUND_BORDER_RADIUS_MEDIUM as Y, CHECKBOX_SMALL_CHECKED_BACKGROUND_PATH_DATA as y, CHECKBOX_MEDIUM_CHECKED_BACKGROUND_PATH_DATA as D, CHECKBOX_SMALL_MARK_PATH_DATA as k, CHECKBOX_MEDIUM_MARK_PATH_DATA as H } from "./constants.js";
import { Icon as Z } from "../Icon/index.js";
import { Loader as q } from "../Loader/index.js";
import { useCheckboxKeyboardEvent as z } from "./hooks/useCheckboxKeyboardEvent.js";
const ee = ({
  checkboxSize: e
}) => {
  const r = _();
  return /* @__PURE__ */ t("path", { fillRule: "evenodd", clipRule: "evenodd", d: {
    medium: H,
    small: k
  }[e], fill: r.colors.secondary.initial });
}, te = ({
  checkboxSize: e,
  isHovered: r
}) => {
  const n = _(), a = {
    medium: {
      rect: D,
      d: H
    },
    small: {
      rect: y,
      d: k
    }
  }, d = r ? n.colors.primary.dark : n.colors.primary.background;
  return /* @__PURE__ */ l(f, { children: [
    /* @__PURE__ */ t("path", { fillRule: "evenodd", clipRule: "evenodd", d: a[e].rect, fill: d }),
    /* @__PURE__ */ t("path", { fillRule: "evenodd", clipRule: "evenodd", d: a[e].d, fill: "white" })
  ] });
}, ne = ({
  checkboxSize: e,
  isHovered: r
}) => {
  const n = _(), a = {
    medium: {
      x: 6,
      y: 11,
      width: 12,
      height: 2.5,
      rx: 0.5,
      d: D
    },
    small: {
      x: 4,
      y: 7.33337,
      width: 8,
      height: 1.66667,
      rx: 0.333333,
      d: y
    }
  }, d = r ? n.colors.primary.dark : n.colors.primary.background;
  return /* @__PURE__ */ l(f, { children: [
    /* @__PURE__ */ t("path", { fillRule: "evenodd", clipRule: "evenodd", d: a[e].d, fill: d }),
    /* @__PURE__ */ t("rect", { x: a[e].x, y: a[e].y, width: a[e].width, height: a[e].height, rx: a[e].rx, fill: "white" })
  ] });
}, re = 1.3, ae = ({
  children: e,
  checkboxSize: r
}) => {
  const n = r === "small" ? V : Y;
  return /* @__PURE__ */ l("g", { children: [
    /* @__PURE__ */ t(Q, { strokeWidth: re, x: "1", y: "1", width: u[r].inner, height: u[r].inner, rx: n, stroke: "red" }),
    e
  ] });
}, Ce = ({
  checked: e = !1,
  onChange: r,
  error: n,
  name: a,
  value: d,
  checkboxSize: i = "small",
  children: I,
  progress: s = !1,
  disabled: C = !1,
  autoFocus: K = !1,
  className: B,
  "data-visibility": O,
  "aria-label": x,
  required: R,
  dataTrackId: T,
  ref: L
}) => {
  const A = N(null), [o, c] = M(e), [h, p] = M(!1);
  z({
    ref: A,
    disabled: C,
    onToggle: () => {
      c((m) => !m);
    }
  });
  const U = () => {
    p(!0);
  }, w = () => {
    p(!1);
  }, v = P(), g = `checkbox-${v}`, E = a ?? v;
  G(() => {
    c(e);
  }, [e]);
  const b = $((m) => {
    s || r?.(m), c((X) => X === "indeterminate" ? !1 : m.target.checked);
  }, [r, s, c]);
  return /* @__PURE__ */ l(f, { children: [
    /* @__PURE__ */ l(j, { className: B, "aria-disabled": C, "data-visibility": O, htmlFor: g, "data-checked": o, "data-error": !!n, "data-track": T, children: [
      s ? /* @__PURE__ */ t(F, { children: /* @__PURE__ */ t(q, {}) }) : null,
      /* @__PURE__ */ t(S, { type: "checkbox", id: g, "aria-invalid": !!n, "aria-describedby": n ? `${E}-hint` : void 0, "aria-checked": o === "indeterminate" ? "mixed" : void 0, "aria-label": x, checked: o === "indeterminate" ? !1 : o, checkboxSize: i, onChange: b, disabled: C, value: d, name: E, autoFocus: K, ref: L, required: R, onMouseEnter: U, onMouseLeave: w }),
      s ? null : /* @__PURE__ */ t(W, { ref: A, tabIndex: 0, checkboxSize: i, viewBox: `0 0 ${u[i].container} ${u[i].container}`, children: /* @__PURE__ */ l(ae, { checkboxSize: i, children: [
        o === "indeterminate" && /* @__PURE__ */ t(ne, { checkboxSize: i, isHovered: h }),
        o && o !== "indeterminate" && /* @__PURE__ */ t(te, { checkboxSize: i, isHovered: h }),
        !o && h && /* @__PURE__ */ t(ee, { checkboxSize: i })
      ] }) }),
      I,
      R ? /* @__PURE__ */ t("sup", { children: /* @__PURE__ */ t(Z, { icon: ["fa-asterisk"], iconSize: "10px", color: "danger" }) }) : null
    ] }),
    n ? /* @__PURE__ */ t(J, { variant: "bodySRegular", as: "p", color: "danger", children: n }) : null
  ] });
};
export {
  te as CheckMark,
  ee as CheckMarkOnHover,
  ne as CheckMixedMark,
  Ce as Checkbox
};
